export const setProfileData = (data) => ({
  type: "SET_PROFILE_DATA",
  payload: data, // Payload contains the profile data
});